module.exports = __webpack_public_path__ + "media/images/bg-O-opaque-3c4382bbb6678156205ac1df9480b27f.svg";